import { RG_TYPE as t } from "@project-rouge/rg-core";
import { getLevelPerimeter as m } from "./index27.js";
const p = (e, r) => m(e, r, [t.EmptySpace]);
export {
  p as getLevelCommercialPerimeter
};
//# sourceMappingURL=index11.js.map
